import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { getBlockFromMap } from '../blocks'
import Context from '../blocks/BlockContext'

/**
 * Generic component to render a WordPress block
 */
const WPBlock = ({ block }) => {
  const { meta } = useContext(Context)
  const { component } = getBlockFromMap(block.blockName)

  // render javascript content by importing its component and returning it
  const Block = component
  return <Block blockName={block.blockName} block={block} meta={meta} />
}

WPBlock.propTypes = {
  /**
   * Blocks received from WordPress
   */
  block: PropTypes.object.isRequired,
}

export default WPBlock
